import { ResourceAssignmentBase } from './base/resource-assignment-base';

export class ResourceAssignment extends ResourceAssignmentBase { }